import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Label } from 'reactstrap';
import { Translate } from 'react-redux-i18n';
import classNames from 'classnames';

const Component = ({ captionKey, check, children, large, withUnit, required }) => {
    const className = classNames({
        'with-unit': withUnit,
        'value-column': true
    });

    return (
        <FormGroup row check={ check }>
            <Label sm={ 2 }>
                <Translate value={ `ad.${ captionKey }` } className={ `field ${ required ? 'required' : '' }` } />
            </Label>
            <Col sm={ large ? 10 : 3 } className={ className }>
                { children }
            </Col>
        </FormGroup>
    );
};

Component.propTypes = {
    captionKey: PropTypes.string,
    check: PropTypes.bool,
    large: PropTypes.bool,
    withUnit: PropTypes.bool,
    required: PropTypes.bool,
};


Component.defaultProps = {
    captionKey: '',
    check: false,
    large: false,
    withUnit: false,
    required: true,
};

export default Component;
